import { render, staticRenderFns } from "./PortalSideMenu.vue?vue&type=template&id=d2280440&"
import script from "./PortalSideMenu.vue?vue&type=script&lang=js&"
export * from "./PortalSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports